/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { EpisodeOfCareStatus } from './EpisodeOfCareStatus';
import {
    EpisodeOfCareStatusFromJSON,
    EpisodeOfCareStatusFromJSONTyped,
    EpisodeOfCareStatusToJSON,
    EpisodeOfCareStatusToJSONTyped,
} from './EpisodeOfCareStatus';

/**
 * 
 * @export
 * @interface EpisodeOfCareSummary
 */
export interface EpisodeOfCareSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    patient_id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    status: EpisodeOfCareStatus;
    /**
     * 
     */
    status_reason: string;
    /**
     * 
     */
    status_reason_display_name: string;
    /**
     * 
     */
    bed_hold: boolean;
    /**
     * 
     */
    bed_hold_end_date: Date;
    /**
     * 
     */
    actual_start_at: Date;
    /**
     * 
     */
    actual_end_at: Date;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    date_modified: Date;
}



/**
 * Check if a given object implements the EpisodeOfCareSummary interface.
 */
export function instanceOfEpisodeOfCareSummary(value: object): value is EpisodeOfCareSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patient_id' in value) || value['patient_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('status_reason' in value) || value['status_reason'] === undefined) return false;
    if (!('status_reason_display_name' in value) || value['status_reason_display_name'] === undefined) return false;
    if (!('bed_hold' in value) || value['bed_hold'] === undefined) return false;
    if (!('bed_hold_end_date' in value) || value['bed_hold_end_date'] === undefined) return false;
    if (!('actual_start_at' in value) || value['actual_start_at'] === undefined) return false;
    if (!('actual_end_at' in value) || value['actual_end_at'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('date_modified' in value) || value['date_modified'] === undefined) return false;
    return true;
}

export function EpisodeOfCareSummaryFromJSON(json: any): EpisodeOfCareSummary {
    return EpisodeOfCareSummaryFromJSONTyped(json, false);
}

export function EpisodeOfCareSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeOfCareSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patient_id': json['patient_id'],
        'facility_id': json['facility_id'],
        'status': EpisodeOfCareStatusFromJSON(json['status']),
        'status_reason': json['status_reason'],
        'status_reason_display_name': json['status_reason_display_name'],
        'bed_hold': json['bed_hold'],
        'bed_hold_end_date': (json['bed_hold_end_date'] == null ? json['bed_hold_end_date'] : parseDate(json['bed_hold_end_date'])),
        'actual_start_at': (json['actual_start_at'] == null ? json['actual_start_at'] : parseDateTime(json['actual_start_at'])),
        'actual_end_at': (json['actual_end_at'] == null ? json['actual_end_at'] : parseDateTime(json['actual_end_at'])),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'date_modified': (json['date_modified'] == null ? json['date_modified'] : parseDateTime(json['date_modified'])),
    };
}

export function EpisodeOfCareSummaryToJSON(json: any): EpisodeOfCareSummary {
    return EpisodeOfCareSummaryToJSONTyped(json, false);
}

export function EpisodeOfCareSummaryToJSONTyped(value?: EpisodeOfCareSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patient_id': value['patient_id'],
        'facility_id': value['facility_id'],
        'status': EpisodeOfCareStatusToJSON(value['status']),
        'status_reason': value['status_reason'],
        'status_reason_display_name': value['status_reason_display_name'],
        'bed_hold': value['bed_hold'],
        'bed_hold_end_date': value['bed_hold_end_date'] == null ? value['bed_hold_end_date'] : serializeDate(value['bed_hold_end_date']),
        'actual_start_at': value['actual_start_at'] == null ? value['actual_start_at'] : serializeDateTime(value['actual_start_at']),
        'actual_end_at': value['actual_end_at'] == null ? value['actual_end_at'] : serializeDateTime(value['actual_end_at']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_modified': value['date_modified'] == null ? value['date_modified'] : serializeDateTime(value['date_modified']),
    };
}

